import { Injectable, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import type {
    PrefillNoticeAnswer,
    PrefillNoticeDialogInput,
} from '../../components/app-layout/shared/prefill-notice-dialog/prefill-notice-dialog.component';

/**
 * Asks the prefill notice for `PrefillNoticeService`, which has no template of its own.
 * `app-bank-account-flow-dialogs-host` at the app root renders the dialog bound to `open` and `data`.
 */
@Injectable({ providedIn: 'root' })
export class PrefillNoticeDialogStateService {
    readonly open = signal(false);
    readonly data = signal<PrefillNoticeDialogInput>({ labels: [] });

    private _result$: Subject<PrefillNoticeAnswer | null> | null = null;

    constructor(location: Location) {
        // Browser back/forward cancels, as MatDialog's closeOnNavigation did.
        location.subscribe(() => this.answer(null));
    }

    ask(data: PrefillNoticeDialogInput): Observable<PrefillNoticeAnswer | null> {
        this.answer(null);
        this._result$ = new Subject<PrefillNoticeAnswer | null>();
        this.data.set(data);
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: PrefillNoticeAnswer | null): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
